<template>
  <div class="list">
    <div class="list-header">
      <div class="header-bg">
        <div class="title">订单查询</div>
        <div class="search">
          <div class="search-input">
            <van-icon class="el-icon-search" name="search" color="#b2b2b2" />
            <input @input="changeNum" v-model="orderText" type="text" placeholder="请输入订单号" />
            <van-icon
              v-if="orderText"
              class="el-icon-error"
              @click="clear"
              name="clear"
              color="#b2b2b2"
            />
          </div>
          <span class="search-btn" @click="search">查询</span>
        </div>
        <p class="name"><van-icon class="wap-home" name="wap-home" />先锋团</p>
      </div>
    </div>

    <div
      v-for="(info, index) in infoList"
      :key="(info.subOrderId || info.mainOrderId) + '-' + index"
      class="order-info"
    >
      <div class="cell-1">
        <div class="order-num-group">
          <p class="order-num main-order-num">主单号：{{ info.mainOrderId || "-" }}</p>
          <p class="order-num sub-order-num">
            子单号：{{ info.subOrderId || "-" }}
            <span v-if="info.userUniqueCode" class="user-code-tag">{{ info.userUniqueCode }}</span>
          </p>
        </div>
      </div>
      <div class="commodity">
        <img
          v-if="info.skuImg"
          class="commodity-img"
          :src="info.skuImg"
          alt=""
        />
        <van-empty v-else class="commodity-img" description="暂无图片" />
        <div class="commodity-info">
          <p
            class="commodity-title"
            :title="info.skuName || '-'"
            @click="showFullName(info.skuName)"
          >{{ info.skuName || "-" }}</p>
          <p class="time">店铺：{{ info.shopName || "-" }}</p>
          <p class="time">下单时间：{{ info.orderTime || "-" }}</p>
          <p class="time">完成时间：{{ info.finishTime || "-" }}</p>
        </div>
      </div>
      <div class="order-footer">
        <p :class="['order-status', getOrderStatusClass(info)]">
          订单状态：{{ getOrderStatusText(info) }}
        </p>
        <p class="pay-price">{{ formatPayPrice(info) }}</p>
      </div>
    </div>

    <div class="tips">
      <p class="system-name">订单查询须知</p>
      <p>1. 可查询京东、淘宝平台的订单是否跟团成功。</p>
      <p>2. 京东订单请在付款前查询，避免退款国补失效。</p>
      <p>3. 提交订单后3-5分钟再查询，确保系统抓取正常。</p>
      <p>4. 如查询结果显示“无该订单信息”为跟团失败，需取消重拍。</p>
      <p>5. 如订单仅显示赠品/凑单品，不显示主商品为无效订单，需取消重拍。</p>
      <p>6. 如订单状态显示“待付款”“已付款”或“已完成”即为跟团成功，可付款。</p>
      <p>
        7. 成功跟团后截图保存，并将订单号发送到群内回复跟团成功，以便团长联系。
      </p>
      <p>8. 付款后订单号可能会更新，请使用最新订单号查询。</p>
      <p>9. 下单时请勿使用京东e卡、京豆、京享礼金及返利软件，避免影响返卡。</p>
      <p>10. 如有疑问，请在团购群联系团长咨询。</p>
    </div>
  </div>
</template>

<script>
import { checkInt } from '../utils/common'
import { Toast } from 'vant'

export default {
  name: "ListPage",
  components: {},
  props: {
    infoList: {
      type: Array,
      default: () => [],
    },
    order: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      orderText: "",
    };
  },
  created() {
    this.orderText = this.order;
  },
  methods: {
    changeNum(){
      this.orderText = this.orderText ? checkInt(this.orderText) : null;
    },
    search() {
      this.$emit("search", this.orderText);
    },
    clear() {
      this.orderText = null;
    },
    showFullName(name) {
      if (!name || name === "-") return;
      Toast({
        className: "toast-msg",
        message: name,
      });
    },
    formatPayPrice(info) {
      const actual = Number(info.actualCosPrice);
      const estimate = Number(info.estimateCosPrice);
      const hasActual =
        info.actualCosPrice !== null &&
        info.actualCosPrice !== undefined &&
        info.actualCosPrice !== "" &&
        !Number.isNaN(actual) &&
        actual !== 0;
      const value = hasActual ? actual : estimate;
      if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) {
        return "-";
      }
      return `¥${Number(value).toFixed(2)}`;
    },
    getOrderStatusText(info) {
      if (Number(info.traceType) === 3) {
        return "无效-跨店";
      }
      return info.ordersStatus || "-";
    },
    getOrderStatusClass(info) {
      if (Number(info.traceType) === 3) {
        return "";
      }
      if (this.isInvalidOrder(info)) {
        return "order-status2";
      }
      if (info.validCode === 15) {
        return "order-status1";
      }
      return "";
    },
    isInvalidOrder(info) {
      return (
        info.validCode === 16 ||
        info.validCode === 17 ||
        (info.ordersStatus || "").includes("无效")
      );
    },
  },
};
</script>

<style scoped>
.list {
  height: 100%;
  background: #f8f8f8;
  overflow-x: hidden;
  overflow-y: scroll;
}
.list-header {
  height: 8.5rem;
  background: linear-gradient(180deg, #e93e37, #f3705e);
  border-radius: 0 0 1rem 1rem;
  position: relative;
}
.header-bg {
  background: url("../assets/images/bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.title {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.search {
  width: 100%;
  padding: 0.4rem 0.8rem;
  display: flex;
  align-items: center;
}
.search-input {
  flex: 1;
  height: 1.8rem;
  position: relative;
}
.search-input input {
  outline: none;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 1.8rem;
  padding: 0 1.8rem;
  font-size: 0.7rem;
  color: #333333;
}
.el-icon-search {
  position: absolute;
  font-size: 0.8rem;
  left: 0.6rem;
  top: 0.5rem;
  color: #b2b2b2;
}
.el-icon-error {
  position: absolute;
  font-size: 0.8rem;
  top: 0.5rem;
  right: 0.5rem;
  color: #b2b2b2;
}
.search-btn {
  width: 2.5rem;
  height: 1.6rem;
  background-color: #ffffff;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 0.7rem;
  font-weight: bold;
  margin-left: 0.5rem;
}
.name {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 1rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.tips {
  border: 0.05rem double #e8e2e3;
  padding: 2rem 0.5rem 0.5rem;
  border-radius: 1rem;
  margin: 1.5rem 0.8rem;
  background: #fef5f6;
  position: relative;
  /*transform: translateY(-1rem);*/
}
.tips p {
  color: #666666;
  font-size: 0.7rem;
  margin-top: 0.5rem;
}
.system-name {
  width: 6rem;
  height: 2rem;
  position: absolute;
  top: -0.05rem;
  left: -0.05rem;
  background: linear-gradient(90deg, #f6584a, #fe6647);
  margin-top: 0 !important;
  border-radius: 1rem 0.25rem 1.5rem 0;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 0.75rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-info {
  margin: 1rem 0.6rem 0;
  box-shadow: 0 0 0.69rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  padding: 0.5rem;
}
.order-info + .order-info {
  margin-top: 0.6rem;
}
.cell-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order-num-group {
  width: 100%;
}
.order-num {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  line-height: 1rem;
}
.main-order-num {
  font-size: 0.65rem;
  color: #999999;
}
.sub-order-num {
  font-size: 0.7rem;
  color: #333333;
  font-weight: 500;
}
.order-num + .order-num {
  margin-top: 0.05rem;
}
.user-code-tag {
  display: inline-block;
  padding: 0.1rem 0.4rem;
  background-color: #3e7df5;
  color: #ffffff;
  border-radius: 0.2rem;
  font-size: 0.6rem;
  font-weight: bold;
}
.commodity {
  display: flex;
  font-size: 0;
  margin-top: 0.5rem;
}
.commodity-img {
  min-width: 5rem;
  width: 5rem;
  height: 5rem;
  border-radius: 0.25rem;
}
.commodity-img >>> .van-empty {
  padding: 0;
}
.commodity-img >>> .van-empty__image {
  width: 3.5rem;
  height: 3.5rem;
}
.commodity-img >>> .van-empty__description {
  font-size: 0.6rem;
  padding: 0;
  margin-top: 0;
}
.commodity-info {
  padding-left: 0.5rem;
  min-width: 0;
  flex: 1;
}
.commodity-title {
  font-size: 0.67rem;
  font-weight: bold;
  line-height: 1rem;
  color: #000000;
  padding-bottom: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.time {
  font-size: 0.6rem;
  color: #000000;
  line-height: 1rem;
}
.order-status {
  font-size: 0.6rem;
  color: #9a9a9a;
  font-weight: bold;
  flex: 1;
  min-width: 0;
  margin-right: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-status1 {
  color: #3e7df5;
}
.order-status2 {
  color: #f3768a;
}
.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.3rem;
}
.pay-price {
  font-size: 0.9rem;
  color: #e93e37;
  font-weight: bold;
  line-height: 1.2rem;
  white-space: nowrap;
  flex-shrink: 0;
}
.wap-home {
  font-size: 1.2rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
  margin-right: 0.2rem;
}
</style>
